import { render, staticRenderFns } from "./notices.vue?vue&type=template&id=7eadc0ae&"
import script from "./notices.vue?vue&type=script&lang=js&"
export * from "./notices.vue?vue&type=script&lang=js&"
import style0 from "./notices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports